import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';

import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

import { CoordinationsOverview, CoordinationsOverviewParams } from './model';
import { CoordinationsOverviewView } from './view';

export function CoordinationsOverviewRoute(
    model : (params : CoordinationsOverviewParams) => CoordinationsOverview,
    appWrapper: AppWrapper,
    _request : Location
) : IRoute {
    const m = model({});
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <CoordinationsOverviewView model={m} />
            </AppWrapperView>
    };
}



// WEBPACK FOOTER //
// ./apps/portcall/coordinationsoverview/route.tsx